import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatDate, formatViews } from "@/utils/format";

interface VideoCardProps {
  video: Video;
  categoryName?: string;
}

export default function VideoCard({ video, categoryName }: VideoCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link
        to={`/detail/${video.id}`}
        className="relative block aspect-video w-full overflow-hidden cursor-pointer"
        aria-label={video.title}
      >
        <img
          src={video.cover}
          alt={`${video.title} 封面图`}
          title={`${video.title} - 黑料视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 to-transparent"></span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-time-line text-[12px]"></i>
          {video.duration}
        </span>
        <span className="absolute left-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
          <i className="ri-play-fill text-lg"></i>
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        {categoryName ? (
          <span className="mb-2 self-start rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
            {categoryName}
          </span>
        ) : null}
        <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-950 md:text-base">
          <Link to={`/detail/${video.id}`} className="hover:text-primary-600 cursor-pointer">
            {video.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {video.excerpt}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {formatDate(video.publishDate)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line"></i>
            {formatViews(video.views)}
          </span>
        </div>
      </div>
    </article>
  );
}